import config from "../../config/environment";

// Export entity configuration for use in routes
export const inspectionEntity = {
  path: config.entities.inspection,
};

const Inspection = () => {
  return null; // This component doesn't render anything
};

export default Inspection;
